import axios from 'axios';
import {
    submissionBegin,
    submissionSuccess,
    submissionFailure
} from '../GenericFormServiceActions/SubmissionAction';
import { addFormSubmissionFailed } from '../../FormPropertyAction/FormPropertyAction';

const convertStudentsToArray = (mplFormData) => {
    const students = Object.values(mplFormData.students).map(student => {
        return {
            ...mplFormData.students[student.studentArn],
            additionalDetails: Object.values(student.additionalDetails).map(question => {
                return (
                    {
                        ...question,
                        answer: {
                            ...question.answer,
                            checkboxes: question.answer.checkboxes ? Object.values(question.answer.checkboxes) : []
                        }
                    }
                )
            })
        }
    })

    return (
        {
            ...mplFormData,
            students: students
        }
    )
}

export const submitMplForm = (webappurlForms, accessToken, formProperties, formData) => {
    return dispatch => {
        const data = {
            "rootFormCode": formProperties.rootFormCode,
            "formCode": formProperties.formCode,
            "formData": convertStudentsToArray(formData),
            "name": formProperties.name,
            "version": formProperties.version,
            "orgid": formProperties.orgid,
            "organisationArn": formProperties.organisationArn,
            "draftRecordId": formProperties.draftRecordId
        }

        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data'
            }
        };

        const students = formData.students;
        const formDataObject = new FormData();
        
        formDataObject.append("request", btoa(JSON.stringify(data)));
        
        Object.keys(students).map(studentArn => {
            return (
                students[studentArn].additionalDetails.studentQualificationEvidence?.answer.fileDetails.map(file => {
                    formDataObject.append("files", file.file, studentArn + "|" + file.name)
                })
            )
        })
        
        dispatch(submissionBegin());
        //TODO: update WebURL
        return axios.post(webappurlForms + "/api/myCASA/Forms/SubmitMpl/v1", formDataObject, options)
            .then(response => {
                if (response.data.wasSuccessful) {
                    return dispatch(submissionSuccess());
                }
                else {
                    dispatch(addFormSubmissionFailed())
                    return dispatch(submissionFailure("System error FSU.1a: " + response.message));
                }
            })
            .catch(error => {
                dispatch(addFormSubmissionFailed())
                return dispatch(submissionFailure(error.response ? error.response.data.errors : error));
            });
    };
}
